export const CustomTagRender = (props) => {
  const { label, closable, onClose } = props;

  return (
    <div className="border-1 mr-[4px] flex items-center rounded-[8px] border-[#91Caff] bg-[#E6F4FF] px-[8px] py-[2px] font-medium text-[#1677ff]">
      <span>{label}</span>
      {closable && (
        <span onClick={onClose} className="ml-[8px] cursor-pointer font-bold">
          ×
        </span>
      )}
    </div>
  );
};
